// extracted by mini-css-extract-plugin
export default {"section":"CreditScoreSection_section__zOXQt","skeletonLoadingAnimation":"CreditScoreSection_skeletonLoadingAnimation__HxGDH"};